import React from 'react';

/**
 * LoteDataSidebar - Sidebar with key stats (Cabezas, Peso, Clase, Estado, Precios)
 */
const LoteDataSidebar = ({ lote }) => {
    return (
        <div className="w-full lg:w-[10%] bg-white rounded shadow-md p-2 grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-1 lg:flex lg:flex-col gap-1.5">
            {/* Cabezas - same for all */}
            <div className="bg-gradient-to-r from-green-50 to-green-100 rounded border border-green-300 text-center py-2 px-2">
                <p className="text-[9px] text-green-700 font-semibold">Cabezas</p>
                <p className="text-xl font-black text-green-900">{lote.cabezas}</p>
            </div>

            {/* For Ovinos (L): show Condición Corporal */}
            {lote.tipo_ganado === 'L' ? (
                <>
                    <div className="bg-purple-50 rounded border border-purple-200 text-center py-2 px-2">
                        <p className="text-[9px] text-purple-700 font-semibold">CC Mínimo</p>
                        <p className="text-lg font-black text-purple-900">{lote.condicion_corporal_min || 'N/A'}</p>
                    </div>
                    <div className="bg-purple-50 rounded border border-purple-200 text-center py-2 px-2">
                        <p className="text-[9px] text-purple-700 font-semibold">CC Máximo</p>
                        <p className="text-lg font-black text-purple-900">{lote.condicion_corporal_max || 'N/A'}</p>
                    </div>
                    <div className="bg-purple-100 rounded border border-purple-300 text-center py-2 px-2">
                        <p className="text-[9px] text-purple-700 font-semibold">CC Promedio</p>
                        <p className="text-lg font-black text-purple-900">{lote.condicion_corporal || 'N/A'}</p>
                    </div>
                </>
            ) : (
                <>
                    {/* Vacunos/Toros: show Peso, Clase, Estado */}
                    <div className="bg-gradient-to-r from-green-50 to-green-100 rounded border border-green-300 text-center py-2 px-2">
                        <p className="text-[9px] text-green-700 font-semibold">Peso</p>
                        <p className="text-lg font-black text-green-900">
                            {lote.peso_promedio}
                            {lote.tiene_peso_terneros && lote.peso_terneros > 0 && (
                                <span className="text-sm ml-0.5 text-green-700">/{lote.peso_terneros}</span>
                            )}
                        </p>
                    </div>
                    {lote.tiene_peso_terneros && lote.peso_terneros > 0 && (
                        <div className="bg-gradient-to-r from-green-50 to-green-100 rounded border border-green-300 text-center py-2 px-2">
                            <p className="text-[9px] text-green-700 font-semibold">Peso Terneros</p>
                            <p className="text-lg font-black text-green-900">{lote.peso_terneros}</p>
                        </div>
                    )}
                    <div className="bg-gradient-to-r from-green-50 to-green-100 rounded border border-green-300 text-center py-2 px-2">
                        <p className="text-[9px] text-green-700 font-semibold">Clase</p>
                        <p className="text-lg font-black text-green-900">{lote.clase === 'Primera' ? 'MBB' : lote.clase === 'Segunda' ? 'BMB' : 'MB'}</p>
                    </div>
                    <div className="bg-gradient-to-r from-green-50 to-green-100 rounded border border-green-300 text-center py-2 px-2">
                        <p className="text-[9px] text-green-700 font-semibold">Estado</p>
                        <p className="text-lg font-black text-green-900">{lote.condicion === 'Excelente' ? 'MBB' : lote.condicion === 'Muy Buena' ? 'BMB' : 'MB'}</p>
                    </div>
                </>
            )}

            {/* Precios */}
            <div className="bg-blue-50 rounded border border-blue-200 text-center py-2 px-2">
                <p className="text-[8px] text-blue-600 font-semibold">Precio Mín</p>
                <p className="text-sm font-black text-blue-800">${lote.precio_min || '0'}</p>
            </div>
            <div className="bg-blue-50 rounded border border-blue-200 text-center py-2 px-2">
                <p className="text-[8px] text-blue-600 font-semibold">Precio Máx</p>
                <p className="text-sm font-black text-blue-800">${lote.precio_max || '0'}</p>
            </div>
            <div className="bg-blue-100 rounded border border-blue-300 text-center py-2 px-2">
                <p className="text-[8px] text-blue-700 font-semibold">Precio Prom</p>
                <p className="text-sm font-black text-blue-900">${lote.precio_promedio || '0'}</p>
            </div>
        </div>
    );
};

export default LoteDataSidebar;
